import React, { Component } from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import NumberFormat from 'react-number-format'

const SECTIONS = [
  { id: 'intake', label: 'รับงาน' },
  { id: 'personal', label: 'ข้อมูลลูกค้า' },
  { id: 'vehicle', label: 'ความต้องการรถ' },
  { id: 'employment', label: 'พนักงานบริษัท' },
  { id: 'business', label: 'ธุรกิจส่วนตัว' },
  { id: 'credit', label: 'ข้อมูลเครดิต' },
  { id: 'obligations', label: 'ภาระผ่อน' },
  { id: 'history', label: 'ประวัติสินเชื่อ' },
  { id: 'banks', label: 'เช็คลิสต์ไฟแนนซ์' },
  { id: 'followup', label: 'ผลติดตาม' }
]

const BANK_CODES = ['AY', 'KK', 'TTB', 'CIMB', 'EAST', 'OALT', 'KL', 'TSCO', 'NLTH', 'AEON']
const STATUS_OPTS = ['ปกติ', 'ติด BL', 'ล่าช้า', 'ปรับโครงสร้าง', 'ไม่มีเครดิต', 'อื่นๆ']

function statusBadgeClass(s) {
  if (s === 'ปกติ') return 'badge badge-success'
  if (s === 'ติด BL' || s === 'ล่าช้า') return 'badge badge-danger'
  if (s) return 'badge badge-warning'
  return 'badge badge-secondary'
}

export default class CustomerCreditForm extends Component {

  scrollTo(id) {
    const el = document.getElementById('sec-' + id)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  cf(name) { return (this.props.customer && this.props.customer[name]) || '' }

  getPath(obj, path) {
    if (!obj) return ''
    return path.split('.').reduce((o, k) => (o == null ? o : o[k]), obj)
  }

  // field on the credit profile (flat top-level)
  field(label, value, path, type) {
    if (type === 'number') {
      return (
        <div className="form-group col-sm-4">
          <label>{label}</label>
          <NumberFormat thousandSeparator={true} className="form-control"
            value={value == null || value === '' ? '' : value}
            onValueChange={(values) => this.props.onChange('profile.' + path, values.floatValue === undefined ? '' : values.floatValue)} />
        </div>
      )
    }
    return (
      <div className="form-group col-sm-4">
        <label>{label}</label>
        <input type={type || 'text'} className="form-control"
          value={value == null ? '' : value}
          onChange={e => this.props.onChange('profile.' + path, e.target.value)} />
      </div>
    )
  }
  custField(label, value, name, type) {
    return (
      <div className="form-group col-sm-6">
        <label>{label}</label>
        <input type={type || 'text'} className="form-control"
          value={value == null ? '' : value}
          onChange={e => this.props.onChange('customer.' + name, e.target.value)} />
      </div>
    )
  }
  check(label, checked, path) {
    return (
      <label className="mr-3"><input type="checkbox" checked={!!checked}
        onChange={e => this.props.onChange('profile.' + path, e.target.checked)}/> {label}</label>
    )
  }

  renderSection(id, title, body) {
    return (
      <div className="card card-accent-primary mb-3" id={'sec-' + id} style={{ scrollMarginTop: 80 }}>
        <div className="card-header"><strong>{title}</strong></div>
        <div className="card-block">{body}</div>
      </div>
    )
  }

  render() {
    const { profile, customer } = this.props
    if (!profile) return <div className="p-4 bg-white rounded border text-muted">ไม่มีข้อมูล</div>

    const obligations = profile.obligations_json || []
    const history = profile.history_json || []
    const banks = profile.banks_json || {}
    const followups = profile.followups_json || []

    return (
      <div className="bg-white rounded border">
        <div className="sticky-top" style={{ background: '#fff', zIndex: 20, padding: '12px 16px 8px', borderBottom: '1px solid #eee' }}>
          <div className="mb-2 d-flex align-items-baseline flex-wrap">
            <strong style={{ fontSize: 18 }}>{customer ? (customer.customer_name + ' ' + (customer.customer_lastname || '')) : 'เพิ่มเครดิตลูกค้าใหม่'}</strong>
            <span className="text-muted ml-3" style={{ fontSize: 15 }}><i className="icon-phone"></i> {customer ? (customer.customer_mobile || '-') : ''}</span>
          </div>
          <Nav pills style={{ flexWrap: 'wrap' }}>
            {SECTIONS.map(s => (
              <NavItem key={s.id}>
                <NavLink href="#" onClick={e => { e.preventDefault(); this.scrollTo(s.id) }}>{s.label}</NavLink>
              </NavItem>
            ))}
          </Nav>
        </div>

        <div className="p-3">
        {this.renderSection('intake', 'ข้อมูลการรับงาน', (
          <div className="row">
            {this.field('วันที่รับงาน', profile.received_date, 'received_date', 'date')}
            {this.field('ช่องทางรับงาน', profile.channel, 'channel')}
          </div>
        ))}

        {this.renderSection('personal', 'ข้อมูลลูกค้า', (
          <div className="row">
            {this.custField('ชื่อ', this.cf('customer_name'), 'customer_name')}
            {this.custField('นามสกุล', this.cf('customer_lastname'), 'customer_lastname')}
            {this.custField('เบอร์ติดต่อ', this.cf('customer_mobile'), 'customer_mobile', 'tel')}
            {this.custField('อายุ', this.cf('customer_age'), 'customer_age', 'number')}
            <div className="form-group col-sm-6">
              <label>เพศ</label>
              <select className="form-control" value={this.cf('customer_gender') || ''}
                onChange={e => this.props.onChange('customer.customer_gender', e.target.value)}>
                <option value="">—</option><option>ชาย</option><option>หญิง</option><option>อื่นๆ</option>
              </select>
            </div>
            <div className="form-group col-sm-6">
              <label>ลักษณะที่พัก</label>
              <select className="form-control" value={this.cf('customer_housing') || ''}
                onChange={e => this.props.onChange('customer.customer_housing', e.target.value)}>
                <option value="">—</option><option>บ้านตัวเอง</option><option>บ้านเช่า</option><option>อื่นๆ</option>
              </select>
            </div>
            <div className="form-group col-sm-12">
              <label>ที่อยู่ปัจจุบัน</label>
              <input className="form-control" value={this.cf('customer_address')}
                onChange={e => this.props.onChange('customer.customer_address', e.target.value)} />
            </div>
          </div>
        ))}

        {this.renderSection('vehicle', 'ความต้องการรถ', (
          <div className="row">
            {this.field('รถที่สนใจ', profile.vehicle_model_interest, 'vehicle_model_interest')}
            {this.field('ค่างวดที่ต้องการ', profile.desired_installment, 'desired_installment', 'number')}
            {this.field('งบดาวน์', profile.down_budget, 'down_budget', 'number')}
          </div>
        ))}

        {this.renderSection('employment', 'พนักงานบริษัท', (
          <div>
            <div className="row">
              {this.field('พนักงานบริษัท', profile.employer, 'employer')}
              {this.field('รายได้/เดือน', profile.employed_income_amt, 'employed_income_amt', 'number')}
              {this.field('อายุงาน', profile.work_years, 'work_years')}
            </div>
            <div className="form-group"><label>หลักฐานรายได้</label><br/>
              {this.check('สลิปเงินเดือน', profile.has_slip, 'has_slip')}
              {this.check('ใบรับรองเงินเดือน', profile.has_certificate, 'has_certificate')}
              {this.check('รับเงินสด', profile.income_cash, 'income_cash')}
            </div>
            <div className="row">
              <div className="form-group col-sm-4">
                <label>สถานะประกันสังคม</label><br/>
                <label className="mr-3"><input type="radio" name="sso_status" checked={profile.sso_status === 'มี'} onChange={() => this.props.onChange('profile.sso_status', 'มี')}/> มี</label>
                <label><input type="radio" name="sso_status" checked={profile.sso_status === 'ไม่มี'} onChange={() => this.props.onChange('profile.sso_status', 'ไม่มี')}/> ไม่มี</label>
              </div>
              {this.field('กี่เดือน', profile.sso_months, 'sso_months')}
              {this.field('รับผ่านบัญชี', profile.bank_account, 'bank_account')}
              <div className="form-group col-sm-4">
                <label>ใบขับขี่</label><br/>
                <label className="mr-3"><input type="radio" name="has_license" checked={profile.has_license === 'มี'} onChange={() => this.props.onChange('profile.has_license', 'มี')}/> มี</label>
                <label><input type="radio" name="has_license" checked={profile.has_license === 'ไม่มี'} onChange={() => this.props.onChange('profile.has_license', 'ไม่มี')}/> ไม่มี</label>
              </div>
            </div>
          </div>
        ))}

        {this.renderSection('business', 'ธุรกิจส่วนตัว', (
          <div className="row">
            {this.field('อาชีพ', profile.business, 'business')}
            {this.field('ทำมากี่ปี', profile.business_years, 'business_years')}
            {this.field('มีเอกสาร', profile.business_docs, 'business_docs')}
            {this.field('รายได้ต่อเดือน', profile.business_income_amt, 'business_income_amt', 'number')}
            {this.field('มีสัญญาเช่าซื้อ/ว่าจ้าง', profile.has_lease_contract, 'has_lease_contract')}
            {this.field('เดินบัญชี', profile.statement, 'statement')}
          </div>
        ))}

        {this.renderSection('credit', 'ข้อมูลเครดิต — สินเชื่อที่มีอยู่', (
          <div>
            <div className="form-group"><label>มีสินเชื่อ</label><br/>
              {this.check('บ้าน', profile.cred_home, 'cred_home')}
              {this.check('รถมอเตอร์ไซค์', profile.cred_motorcycle, 'cred_motorcycle')}
              {this.check('รถยนต์', profile.cred_car, 'cred_car')}
              {this.check('บัตรเครดิต', profile.cred_credit_card, 'cred_credit_card')}
              {this.check('เงินกู้', profile.cred_personal_loan, 'cred_personal_loan')}
              {this.check('รีไฟแนนซ์', profile.cred_refinance, 'cred_refinance')}
              {this.check('อื่นๆ', profile.cred_other, 'cred_other')}
            </div>
            <div className="row">{this.field('รายละเอียดอื่นๆ', profile.cred_other_note, 'cred_other_note')}</div>
            <div className="form-group">
              <label>สถานะการผ่อน </label>
              <span className={statusBadgeClass(profile.credit_status)}>{profile.credit_status || '—'}</span>
            </div>
            <div className="form-group">
              {STATUS_OPTS.map(opt => (
                <label key={opt} className="mr-2">
                  <input type="radio" name="credit_status" checked={profile.credit_status === opt}
                    onChange={() => this.props.onChange('profile.credit_status', opt)}/> {opt}
                </label>
              ))}
            </div>
            {profile.credit_status === 'อื่นๆ' && (
              <div className="form-group">
                <input className="form-control" placeholder="ระบุสถานะ..."
                  value={profile.credit_status_other || ''}
                  onChange={e => this.props.onChange('profile.credit_status_other', e.target.value)} />
              </div>
            )}
          </div>
        ))}

        {this.renderSection('obligations', 'ภาระการผ่อนต่อเดือน', (
          <div>
            <table className="table table-striped">
              <thead><tr><th>#</th><th>ไฟแนนซ์</th><th>ค่างวด</th><th>ผ่อนมาแล้ว</th></tr></thead>
              <tbody>
                {obligations.map((o, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td><input className="form-control" value={o.name || ''}
                      onChange={e => this.props.onArrayChange('obligations_json', i, 'name', e.target.value)} /></td>
                    <td><NumberFormat thousandSeparator={true} className="form-control"
                      value={o.installment || ''}
                      onValueChange={(values) => this.props.onArrayChange('obligations_json', i, 'installment', values.floatValue === undefined ? '' : values.floatValue)} /></td>
                    <td><input className="form-control" value={o.paidSoFar || ''}
                      onChange={e => this.props.onArrayChange('obligations_json', i, 'paidSoFar', e.target.value)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row mt-3">
              <div className="form-group col-sm-4 ml-auto">
                <label>รวมภาระ (บาท)</label>
                <NumberFormat thousandSeparator={true} className="form-control bg-light" readOnly
                  value={obligations.reduce((s, o) => s + (parseFloat(o.installment) || 0), 0)} />
              </div>
            </div>
          </div>
        ))}

        {this.renderSection('history', 'เคยทำ/ขอสินเชื่อภายใน 1 ปี', (
          <div>
            <table className="table table-striped">
              <thead><tr><th>#</th><th>ระยะเวลา</th><th>ไฟแนนซ์</th><th>ที่ไหน</th></tr></thead>
              <tbody>
                {history.map((h, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td><input className="form-control" value={h.period || ''}
                      onChange={e => this.props.onArrayChange('history_json', i, 'period', e.target.value)} /></td>
                    <td><input className="form-control" value={h.finance || ''}
                      onChange={e => this.props.onArrayChange('history_json', i, 'finance', e.target.value)} /></td>
                    <td><input className="form-control" value={h.where || ''}
                      onChange={e => this.props.onArrayChange('history_json', i, 'where', e.target.value)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}

        {this.renderSection('banks', 'เช็คลิสต์ธนาคาร/ไฟแนนซ์ที่ยื่น', (
          <div>
            <div className="row">
              {BANK_CODES.map(code => {
                const item = banks[code] || { on: false, note: '' }
                return (
                  <div className="col-sm-6" key={code}>
                    <div className="form-inline mb-2">
                      <label className="mr-2" style={{ width: 60 }}>
                        <input type="checkbox" checked={!!item.on}
                          onChange={e => this.props.onBankChange(code, 'on', e.target.checked)}/> {code}
                      </label>
                      <input className="form-control" placeholder="หมายเหตุ" value={item.note || ''}
                        onChange={e => this.props.onBankChange(code, 'note', e.target.value)} />
                    </div>
                  </div>
                )
              })}
            </div>
            <div className="row mt-2">{this.field('อื่นๆ', profile.banks_other, 'banks_other')}</div>
          </div>
        ))}

        {this.renderSection('followup', 'ผลติดตาม', (
          <div>
            <table className="table table-striped">
              <thead><tr><th>ครั้งที่</th><th>วันที่</th><th>บันทึก</th></tr></thead>
              <tbody>
                {followups.map((f, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td><input className="form-control" type="date" value={f.date || ''}
                      onChange={e => this.props.onArrayChange('followups_json', i, 'date', e.target.value)} /></td>
                    <td><input className="form-control" value={f.note || ''}
                      onChange={e => this.props.onArrayChange('followups_json', i, 'note', e.target.value)} /></td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-4 text-right">
              {this.props.canDelete && (
                <button className="btn btn-danger mr-2" onClick={this.props.onDelete}><i className="fa fa-remove"></i> ลบ</button>
              )}
              <button className="btn btn-success" onClick={this.props.onSave}><i className="icon-check"></i> บันทึก</button>
            </div>
          </div>
        ))}
        </div>
      </div>
    )
  }
}
